import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/jornadas`;

// Función para obtener las jornadas
export const getJornadasByIdGrupoAndTemporada = async (
  idGrupo,
  idTemporada,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idGrupo}/${idTemporada}`,
      {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las jornadas");
  } catch (error) {
    throw error;
  }
};

export const getJornadasByIdGrupoAndTemporadaAndJornada = async (
  idGrupo,
  idTemporada,
  numJornada,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idGrupo}/${idTemporada}/${numJornada}`,
      {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las jornadas");
  } catch (error) {
    throw error;
  }
};
